import { Drawer } from "@mui/material";
// config
import colors from "../../../config/colors";
import { DRAWER } from "../../../config/nav";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
import { setSimilarCreatorDetails } from "../../../redux/slices/creator";
// sections
import { SimiliarCreatorDetails } from "../../../sections/Discover/details";

const SimiliarCreatorDetailsDrawer = () => {
  const dispatch = useDispatch();
  const similarCreatorDetails = useSelector(
    (state) => state.creator.similarCreatorDetails,
  );
  const isSimilarCreatorDrawerOpen = !!similarCreatorDetails;
  const handleCloseDrawer = () => {
    dispatch(setSimilarCreatorDetails(null));
  };

  return (
    <Drawer
      anchor="right"
      open={isSimilarCreatorDrawerOpen}
      onClose={handleCloseDrawer}
      sx={{
        "& .MuiDrawer-paper": {
          width: DRAWER.W_CREATOR_DETAILS,
          backgroundColor: colors.white,
          boxShadow: "0px 8px 32px rgba(0, 0, 0, 0.12)",
        },
      }}
    >
      <SimiliarCreatorDetails />
    </Drawer>
  );
};

export default SimiliarCreatorDetailsDrawer;
